import { MissionRewardSelectMethodType } from '@web/gql/graphql'

export const selectMethodLableMap = {
  [MissionRewardSelectMethodType.Pick]: '선정',
  [MissionRewardSelectMethodType.Random]: '랜덤 추첨',
  [MissionRewardSelectMethodType.All]: '100% 당첨',
  [MissionRewardSelectMethodType.RandomWithBenefit]: '랜덤 추첨',
}

export const selectMethodSummaryLableMap = {
  ...selectMethodLableMap,
  [MissionRewardSelectMethodType.Random]: '추첨',
  [MissionRewardSelectMethodType.RandomWithBenefit]: '추첨',
}

export const toShortUnit = (num: number) => {
  return num.toString().replace(/0000$/g, '만').replace(/000$/g, '천')
}
